// modalManager.ts

const modalStack: string[] = [];
let originalBodyOverflow = "";

/**
 * Регистрирует открытие модального окна.
 * Если это первое окно в стеке, блокирует скролл страницы и сохраняет исходное состояние.
 */
export const registerModal = (id: string): void => {
  modalStack.push(id);
  if (modalStack.length === 1) {
    originalBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
};

/**
 * Снимает регистрацию модального окна при его закрытии или размонтировании.
 * Если это было последнее окно в стеке, восстанавливает исходное состояние скролла.
 */
export const unregisterModal = (id: string): void => {
  const index = modalStack.indexOf(id);
  if (index !== -1) {
    modalStack.splice(index, 1); // Удаляем элемент, сохраняя порядок остальных
  }
  
  if (modalStack.length === 0) {
    document.body.style.overflow = originalBodyOverflow;
  }
};

/**
 * Проверяет, является ли данное модальное окно последним открытым (верхним в стеке).
 * Это необходимо, чтобы клавиша ESC закрывала только активное модальное окно, 
 * а не все открытые окна одновременно.
 */
export const isTopModal = (id: string): boolean => {
  return modalStack.length > 0 && modalStack[modalStack.length - 1] === id;
};